module.exports = __webpack_public_path__ + "img/quickpay.beb54208.png";